import './signup.scss'
import Navbar from "./navbar";
import $ from 'jquery';
import React, { Component } from "react";
import { auth, logInWithEmailAndPassword, logout, registerWithEmailAndPassword, } from "../firebase";


export default class signup extends Component {

    constructor() {
        super();

        this.state = {
            name: '',
            email: '',
            password: '',
            user: '#',
            clicked: 0
        }

        this.onChange = this.onChange.bind(this);

    }

    componentDidMount = () => {
        this.myfunction();
        // if (this.state.loading) {
        //     // maybe trigger a loading screen
        //     return;
        //   }
        if (this.state.clicked == 1) {
            this.setState({ clicked: 0 })
        }
        if (this.state.user == this.state.email) {
            //window.open(window.location.href+'/dashboard');
        }

        //this.props.navigation.navigate('/dashboard')
        //navigate("/dashboard");
        //Login();

    }

    componentDidUpdate = () => {
        this.myfunction();

        //console.log(auth);
        console.log(this.state);
        // if (this.state.loading) {
        //     // maybe trigger a loading screen
        //     return;
        //   }

        if (this.state.user == this.state.email && this.state.clicked != 0) {
            //window.open(window.location.href+'/dashboard',"_self");
        }
        if (this.state.clicked == 1) {
            this.setState({ clicked: 0 })
        }

        //   window.location.href="http://localhost:3000/dashboard"
        //this.props.navigation.navigate('/dashboard') 
        //navigate("/dashboard");

        //Login();
    }
    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });

    }
    myfunction = () => {
        $('.form').find('input, textarea').on('keyup blur focus', function (e) {

            var $this = $(this),
                label = $this.prev('label');

            if (e.type === 'keyup') {
                if ($this.val() === '') {
                    label.removeClass('active highlight');
                } else {
                    label.addClass('active highlight');
                }
            } else if (e.type === 'blur') {
                if ($this.val() === '') {
                    label.removeClass('active highlight');
                } else {
                    label.removeClass('highlight');
                }
            } else if (e.type === 'focus') {

                if ($this.val() === '') {
                    label.removeClass('highlight');
                }
                else if ($this.val() !== '') {
                    label.addClass('highlight');
                }
            }

        });

        $('.tab a').on('click', function (e) {

            e.preventDefault();

            $(this).parent().addClass('active');
            $(this).parent().siblings().removeClass('active');

            let target = $(this).attr('href');

            $('.tab-content > div').not(target).hide();

            $(target).fadeIn(600);

        });
    }
    render() {


        return (
            <div>
                <Navbar />
                <div class="form">

                    <ul class="tab-group">
                        <li class="tab active"><a href="#signup">Sign Up</a></li>
                        <li class="tab"><a href="#login">Log In</a></li>
                    </ul>

                    <div class="tab-content">
                        <div id="signup">
                            <h1>Sign Up</h1>

                            <form >

                                <div class="top-row">
                                    <div class="field-wrap">
                                        <label>
                                            First Name<span class="req">*</span>
                                        </label>
                                        <input type="text" required autocomplete="off" name="name" onChange={this.onChange} />
                                    </div>

                                    <div class="field-wrap">
                                        <label>
                                            Last Name<span class="req">*</span>
                                        </label>
                                        <input type="text" required autocomplete="off" />
                                    </div>
                                </div>

                                <div class="field-wrap">
                                    <label>
                                        Email Address<span class="req">*</span>
                                    </label>
                                    <input type="email" required autocomplete="off" name="email" onChange={this.onChange} />
                                </div>

                                <div class="field-wrap">
                                    <label>
                                        Set A Password<span class="req">*</span>
                                    </label>
                                    <input type="password" required autocomplete="off" name="password" onChange={this.onChange} />
                                </div>



                            </form>
                            <button class="button button-block" onClick={() => { console.log('hi'); registerWithEmailAndPassword(this.state.name, this.state.email, this.state.password); this.setState({ user: auth.currentUser.email, clicked: 1 }) }}>Get Started</button>

                        </div>

                        <div id="login">
                            <h1>Welcome!!!</h1>

                            <form >

                                <div class="field-wrap">
                                    <label>
                                        Email Address<span class="req">*</span>
                                    </label>
                                    <input type="email" required autocomplete="off" name="email"
                                        onChange={this.onChange} />
                                </div>

                                <div class="field-wrap">
                                    <label>
                                        Password<span class="req">*</span>
                                    </label>
                                    <input type="password" required autocomplete="off" name="password" onChange={this.onChange} />
                                </div>





                            </form>
                            <button class="button button-block" onClick={() => { logInWithEmailAndPassword(this.state.email, this.state.password); console.log(auth.currentUser.email); this.setState({ user: auth.currentUser.email, clicked: 1 }) }} >Log In</button>

                        </div>

                    </div >

                </div >
            </div>
        );
    }

}